import React from 'react';
import { useSelector } from 'react-redux';
import {
  getSelectedArea,
  getSelectedArrow,
  getSelectedLine,
  getSelectedText,
  getSelectedSquare,
  getSelectedCircle,
  getSelectedLegend,
} from '../../../../store/lixaniPaint/slices/drawingToolSlice';
import { AreaSettings } from './AreaSettings/AreaSettings';
import { LineSettings } from './LineSettings/LineSettings';
import { TextSettings } from './TextSettings/TextSettings';
import { ArrowSettings } from './ArrowSettings/ArrowSettings';
import { LegendSettings } from './LegendSettings/LegendSettings';

export const ToolCustomizer = () => {
  const selectedArea = useSelector(getSelectedArea);
  const selectedArrow = useSelector(getSelectedArrow);
  const selectedLine = useSelector(getSelectedLine);
  const selectedText = useSelector(getSelectedText);
  const selectedSquare = useSelector(getSelectedSquare);
  const selectedCircle = useSelector(getSelectedCircle);
  const selectedLegend = useSelector(getSelectedLegend);

  if (selectedArea || selectedSquare || selectedCircle)
    return (
      <div>
        <AreaSettings />
      </div>
    );
  if (selectedLegend) {
    return (
      <div>
        <LegendSettings />
      </div>
    );
  }
  if (selectedLine)
    return (
      <div>
        <LineSettings />
      </div>
    );
  if (selectedText)
    return (
      <div>
        <TextSettings />
      </div>
    );
  if (selectedArrow)
    return (
      <div>
        <ArrowSettings />
      </div>
    );
  return null;
};
